import styled from "styled-components";

export const CartGroupContainerWrapper = styled.div(({ theme }) => ({
    marginBottom: theme.spacing.medium,
    "& > div": {
        padding: `${theme.spacing.empty} !important`,
    },
}));
